module.exports = __webpack_public_path__ + "static/media/r2-3.a11d3330.jpg";